import { Box, Group, Text, BoxProps } from '@mantine/core';

interface ColumnDefinition {
  label: string | React.ReactNode;
  align?: 'left' | 'center' | 'right';
  props?: BoxProps;
}

interface TableHeaderProps extends BoxProps {
  columns: ColumnDefinition[];
}

export function TableHeader({ columns, ...boxProps }: TableHeaderProps) {
  return (
    <Box
      px="md"
      pb="xs"
      mb="xs"
      style={{
        borderBottom: '1px solid var(--mantine-color-gray-3)',
      }}
      {...boxProps}
    >
      <Group justify="space-between" wrap="nowrap">
        {columns.map((column, index) => (
          <Box
            key={index}
            style={{
              textAlign: column.align || 'left',
            }}
          >
            <Text size="xl" fw={600} c="gray.7">
              {column.label}
            </Text>
          </Box>
        ))}
      </Group>
    </Box>
  );
}
